export class AppHelper {

    closeDatePicker(event: any, datePicker: any) {
        if (event.target.offsetParent == null) {
            datePicker.close();
        }
        else if (event.target.offsetParent.nodeName !== "NGB-DATEPICKER") {
            datePicker.close();
        }
    }
}